export default "__VITE_ASSET__CuVvLlfs__"